import React, { useState, useRef, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import cN from 'classnames';
import { I_Type } from '@Redux/search/interfaces';
import { ArrowUp } from '@components/Common/Icons/index';
import styles from '../styles.module.scss';
import Type from './Type';

interface I_Props {
    CategoryCode: string;
    TypeList: I_Type[];
}

const Category: React.FC<I_Props> = ({ CategoryCode, TypeList }) => {
    // typeList 是否超過一行
    const [isOverflow, setIsOverflow] = useState<boolean>(false);
    const [isExtended, setIsExtended] = useState<boolean>(false);
    const listRef = useRef<HTMLUListElement>(null);

    const isPc = useMediaQuery({ query: '(min-width: 980px)' });

    useEffect(() => {
        // PC 版時 && 所有標籤的高度超過 1 行以上
        isPc && listRef.current?.scrollHeight! > 35 && setIsOverflow(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [listRef]);

    const CategoryName = (() => {
        switch (CategoryCode) {
            case '01':
                return '產品規格';
            case '02':
                return '行銷活動';
            default:
                return '';
        }
    })();

    return (
        <div className={styles.category}>
            <div className={styles.ListTile}>
                <span>{CategoryName}</span>
            </div>
            <ul
                className={cN(styles.typeList, {
                    [`${styles.isExtended}`]: isExtended,
                })}
                key={CategoryCode}
                ref={listRef}
            >
                {TypeList.map(({ TypeCode, TripTypeCode, TripTypeName, GroupList }: I_Type) => (
                    <Type
                        key={TypeCode}
                        TripTypeCode={TripTypeCode}
                        TripTypeName={TripTypeName}
                        GroupList={GroupList}
                        CategoryCode={CategoryCode}
                    />
                ))}
            </ul>
            {isPc && isOverflow && (
                <div className={styles.ListToggleBtn} onClick={() => setIsExtended(!isExtended)}>
                    <span>{isExtended ? '收起' : '更多'}</span>
                    <div className={cN(styles.Icon, { up: isExtended })}>
                        <ArrowUp fill="#3ea5d9" />
                    </div>
                </div>
            )}
        </div>
    );
};

export default Category;
